export const INSPIRE_CONTROL_MESSAGE_TYPE = "wisefriend.inspire.control"
export const INSPIRE_CONTROL_ACK_TYPE = "wisefriend.inspire.control.ack"

export type InspireControlAction = "start" | "stop" | "share" | "unshare" | "close"

export type InspireControlMessage = {
  type: typeof INSPIRE_CONTROL_MESSAGE_TYPE
  meetingId: string
  activityId: string
  action: InspireControlAction
}

export type InspireControlAckMessage = {
  type: typeof INSPIRE_CONTROL_ACK_TYPE
  meetingId: string
  activityId: string
  action: InspireControlAction
  accepted: boolean
  active: boolean
}

export const isInspireControlMessage = (value: unknown): value is InspireControlMessage => {
  if (!value || typeof value !== "object") return false
  const candidate = value as Partial<InspireControlMessage>
  return candidate.type === INSPIRE_CONTROL_MESSAGE_TYPE &&
    typeof candidate.meetingId === "string" &&
    typeof candidate.activityId === "string" &&
    candidate.activityId.length > 0 &&
    ["start", "stop", "share", "unshare", "close"].includes(candidate.action || "")
}

export const isInspireControlAckMessage = (value: unknown): value is InspireControlAckMessage => {
  if (!value || typeof value !== "object") return false
  const candidate = value as Partial<InspireControlAckMessage>
  return candidate.type === INSPIRE_CONTROL_ACK_TYPE &&
    typeof candidate.meetingId === "string" &&
    typeof candidate.activityId === "string" &&
    ["start", "stop", "share", "unshare", "close"].includes(candidate.action || "") &&
    typeof candidate.accepted === "boolean" &&
    typeof candidate.active === "boolean"
}
